
import request from '@/utils/request'

export function getMsg(type) {
  return request({
    url: 'api/getMessage?type='+type,
    method: 'get'
  })
}

export function update(item){
	
	return request({
	  url: 'api/updateMessage',
	  method: 'post',
	  data:item
	})
	
	
}